/**
 * Cart API 错误类型
 * 
 * API 层职责：识别 HTTP 状态码和传输层错误
 * 严禁包含业务错误码（如库存超限等业务语义）
 */
export type CartApiErrorType =
  | 'NETWORK'              // 网络错误（fetch 失败、5xx）
  | 'TIMEOUT'              // 请求超时
  | 'RATE_LIMIT'           // API 限流（429）
  | 'SHOPIFY_VALIDATION'   // Shopify 验证错误（4xx）
  | 'UNKNOWN';             // 未知错误

/**
 * 通用的购物车 API 错误类
 */
export class CartApiError extends Error {
  /** 错误类型 */
  type: CartApiErrorType;
  /** HTTP 状态码 */
  status?: number;
  /** API 返回的原始错误对象 */
  raw?: unknown;
  /** API 返回的原始响应体文本（用于 Validation 关键词匹配） */
  bodyText?: string;
  /** 附加上下文信息 */
  context?: Record<string, any>;

  /**
   * 创建一个 CartApiError 实例
   * @param params - 错误初始化参数
   * @param params.type - 错误分类
   * @param params.message - 错误文案
   * @param params.status - HTTP 状态码
   * @param params.raw - 原始响应体对象
   * @param params.bodyText - 原始响应体文本
   * @param params.context - 额外上下文
   */
  constructor(params: {
    type: CartApiErrorType;
    message: string;
    status?: number;
    raw?: unknown;
    bodyText?: string;
    context?: Record<string, any>;
  }) {
    super(params.message);
    this.name = 'CartApiError';
    this.type = params.type;
    this.status = params.status;
    this.raw = params.raw;
    this.bodyText = params.bodyText;
    this.context = params.context;
    Object.setPrototypeOf(this, CartApiError.prototype);
  }
}

